module.exports = __webpack_public_path__ + "static/media/gray.36240b2a.svg";